import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  OnDestroy
} from "@angular/core";
import { QRScanner, QRScannerStatus } from "@ionic-native/qr-scanner";
import { AlertController, Platform, ModalController } from "ionic-angular";
import { EventTicketConfirmPage } from "../../pages/event-ticket-confirm/event-ticket-confirm";
import { NavData } from "../../models/eventNavigation.model";
/**
 * Generated class for the EventTicketScanComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: "event-ticket-scan",
  templateUrl: "event-ticket-scan.html"
})
export class EventTicketScanComponent implements OnInit, OnDestroy {
  @Output() scanSuccess: EventEmitter<any> = new EventEmitter<any>();

  scanSub: any;

  constructor(
    private qrScanner: QRScanner,
    private alertCtrl: AlertController,
    private platform: Platform,
    private modalCtrl: ModalController
  ) {}

  ngOnInit() {
    if (this.platform.is('cordova')) {
      this.scan();
      this.showCamera();
    }
  }

  ngOnDestroy() {
    this.hideCamera();
    if (this.platform.is('cordova')) {
      this.qrScanner.hide(); // hide camera preview
      this.scanSub.unsubscribe(); // stop scanning
    }
  }

  scan() {
    // Optionally request the permission early
    this.qrScanner
      .prepare()
      .then((status: QRScannerStatus) => {
        if (status.authorized) {
          // camera permission was granted

          this.startScan();

          this.qrScanner.resumePreview().then();

          // show camera preview
          this.qrScanner.show().then();
        } else if (status.denied) {
          // camera permission was permanently denied
          // you must use QRScanner.openSettings() method to guide the user to the settings page
          // then they can grant the permission from there
        } else {
          // permission was denied, but not permanently. You can ask for permission again at a later time.
        }
      })
      .catch((e: any) => this.scan());
  }

  startScan() {
    // start scanning
    this.scanSub = this.qrScanner.scan().subscribe((text: string) => {
      const qr = JSON.parse(text);
      if (qr && qr.reservationUid && qr.userUid) {
        // this.adminCheckIn(qr);
        this.adminCheckIn(qr);
      }
      // this.qrScanner.hide(); // hide camera preview
      this.scanSub.unsubscribe(); // stop scanning
    });
  }

  showCamera() {
    (window.document.querySelector("ion-app") as HTMLElement).classList.add(
      "cameraView"
    );
  }

  hideCamera() {
    (window.document.querySelector("ion-app") as HTMLElement).classList.remove(
      "cameraView"
    );
  }

  // adminCheckIn(req: any) {
  //   let confirm = this.alertCtrl.create({
  //     title: "This is a valid ticket",
  //     message: "Do you want to continue with check in?",
  //     cssClass: "welcome-message",
  //     buttons: [
  //       {
  //         text: "No",
  //         handler: () => {
  //           this.startScan();
  //         }
  //       },
  //       {
  //         text: "Yes",
  //         handler: () => {
  //           this.scanSuccess.emit(req);
  //           this.startScan();
  //         }
  //       }
  //     ]
  //   });
  //   confirm.present();
  // }

  adminCheckIn(req: any) {
    let myModal = this.modalCtrl.create('EventTicketConfirmPage', { userId: req.userUid }, {
      cssClass: 'event-navigation-btn',
    });
    myModal.onDidDismiss((data?: NavData) => {
      if (data) {
        this.scanSuccess.emit(req);
        this.startScan();
      } else {
        this.startScan();
      }
    });
    myModal.present();
  }
}



// WEBPACK FOOTER //
// ./src/components/event-ticket-scan/event-ticket-scan.ts